// src/reducers/bundleReducer.js

import {
    CREATE_BUNDLE_REQUEST,
    CREATE_BUNDLE_SUCCESS,
    CREATE_BUNDLE_FAILURE,
  } from '../actions/bundleActions';
  
  const initialState = {
    loading: false,
    error: null,
    successMessage: '',
  };
  
  const bundleReducer = (state = initialState, action) => {
    switch (action.type) {
      case CREATE_BUNDLE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case CREATE_BUNDLE_SUCCESS:
        return {
          ...state,
          loading: false,
          successMessage: 'Bundle created successfully!',
        };
      case CREATE_BUNDLE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default bundleReducer; 
  